// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_you_may_like = /** @type {(inputs: {}) => string} */ () => {
	return `You may also like`
};

const el_you_may_like = /** @type {(inputs: {}) => string} */ () => {
	return `Πώς σας φαίνονται αυτά;`
};

const ru_you_may_like = /** @type {(inputs: {}) => string} */ () => {
	return `Вам также может понравиться`
};

const he_you_may_like = /** @type {(inputs: {}) => string} */ () => {
	return `אולי תאהבו גם`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "el" | "ru" | "he" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const you_may_like = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.you_may_like(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("you_may_like", locale)
	if (locale === "en") return en_you_may_like(inputs)
	if (locale === "el") return el_you_may_like(inputs)
	if (locale === "ru") return ru_you_may_like(inputs)
	if (locale === "he") return he_you_may_like(inputs)
	return "you_may_like"
};